import { SelectionGenericRoutingModule } from './selection-generic.routing.module';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';
import { FuseWidgetModule } from '../fuse/components/widget/widget.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'app/angular-material.module';
import { SharedModule } from '../common/shared.module';
import { MainFiltersComponent } from './components/main-filters/main-filters.component';
import { TabFiltersComponent } from './components/tab-filters/tab-filters.component';
import { SelectionListComponent } from './components/selection-list/selection-list.component';
import { LeavePanelComponent } from './components/leave-panel/leave-panel.component';
import { SelectionGenericComponent } from './selection-generic.component';
import { SelectionGenericService } from './services/selection-generic.service';
import { TareaListComponent } from './components/selection-list/tarea-list/tarea-list.component';
import { TaskTabComponent } from './components/tab-filters/task-tab/task-tab.component';
import { MoreFilterPopupComponent } from './components/main-filters/more-filter-popup/more-filter-popup.component';
import { TaskFilterComponent } from './components/main-filters/more-filter-popup/task-filter/task-filter.component';
import { EmployeeFilterComponent } from './components/main-filters/common-filters/employee-filter/employee-filter.component';
import { AttributesFilterComponent } from './components/main-filters/common-filters/attributes-filter/attributes-filter.component';
import { EmployeeSelectionFiltersComponent } from './components/main-filters/employee-selection-filters/employee-selection-filters.component';
import { EmployeeListComponent } from './components/selection-list/employee-list/employee-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PopupsComponent } from './components/popups/popups.component';
import { FuseShortcutsModule } from '../fuse/components/shortcuts/shortcuts.module';
import { LeaveTypeFilterComponent } from './components/main-filters/common-filters/leave-type-filter/leave-type-filter.component';
import { DatePeriodFilterComponent } from './components/main-filters/common-filters/date-period-filter/date-period-filter.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DiagnosisFilterComponent } from './components/main-filters/common-filters/diagnosis-filter/diagnosis-filter.component';
import { DiagnosisMenuItemComponent } from './components/main-filters/common-filters/diagnosis-filter/diagnosis-menu-item/diagnosis-menu-item.component';
import { ConsentimientoFilterComponent } from './components/main-filters/common-filters/consentimiento-filter/consentimiento-filter.component';
import { LeaveSelectionFiltersComponent } from './components/main-filters/leave-selection-filters/leave-selection-filters.component';
import { LeaveFilterComponent } from './components/main-filters/more-filter-popup/leave-filter/leave-filter.component';
import { LeaveListComponent } from './components/selection-list/leave-list/leave-list.component';
import { DaysFilterComponent } from './components/main-filters/more-filter-popup/leave-filter/days-filter/days-filter.component';
import { MarcaFilterComponent } from './components/main-filters/more-filter-popup/leave-filter/marca-filter/marca-filter.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { EmpFilterComponent } from './components/main-filters/more-filter-popup/emp-filter/emp-filter.component';
import { MatTooltipModule } from '@angular/material/tooltip'; 
import { ActuationSelectionFilterComponent } from './components/main-filters/actuation-selection-filter/actuation-selection-filter.component';
import { ActuationFilterComponent } from './components/main-filters/more-filter-popup/actuation-filter/actuation-filter.component';
import { ActuationListComponent } from './components/selection-list/actuation-list/actuation-list.component';
import { TaskSelectionFiltersComponent } from './components/main-filters/task-selection-filters/task-selection-filters.component';
import { ActionTypeTreeViewComponent } from './components/main-filters/more-filter-popup/actuation-filter/action-type-tree-view/action-type-tree-view.component';
import { ComentariopopupComponent } from './components/popups/comentariopopup/comentariopopup.component';
import { AutorFilterComponent } from './components/main-filters/common-filters/autor-filter/autor-filter.component';
import { TaskTypeTreeViewComponent } from './components/main-filters/more-filter-popup/task-filter/task-type-tree-view/task-type-tree-view.component';
import { TaskTrasferPopupComponent } from './components/popups/task-trasfer-popup/task-trasfer-popup.component';
import { TaskChangeDateComponent } from './components/popups/task-trasfer-popup/task-change-date/task-change-date.component';
import { TransferMedicoComponent } from './components/popups/task-trasfer-popup/transfer-medico/transfer-medico.component';
import { TransferAdministrativasComponent } from './components/popups/task-trasfer-popup/transfer-administrativas/transfer-administrativas.component';
import { OrdernFilterComponent } from './components/main-filters/common-filters/ordern-filter/ordern-filter.component';
import { RecordingsPanelComponent } from './components/recordings-panel/recordings-panel.component';
import { LeaveReportPopupComponent } from './components/popups/leave-report-popup/leave-report-popup.component';
import { TasksChangePopupComponent } from './components/popups/tasks-change-popup/tasks-change-popup.component';

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    declarations: [
        SelectionGenericComponent,
        MainFiltersComponent,
        TabFiltersComponent,
        SelectionListComponent,
        LeavePanelComponent,
        TareaListComponent,
        TaskTabComponent,
        MoreFilterPopupComponent,
        TaskFilterComponent,
        EmployeeFilterComponent,
        AttributesFilterComponent,
        EmployeeSelectionFiltersComponent,
        EmployeeListComponent,
        PopupsComponent,
        LeaveTypeFilterComponent,
        DatePeriodFilterComponent,
        DiagnosisFilterComponent,
        DiagnosisMenuItemComponent,
        ConsentimientoFilterComponent,
        LeaveSelectionFiltersComponent,
        LeaveFilterComponent,
        LeaveListComponent,
        DaysFilterComponent,
        MarcaFilterComponent,
        EmpFilterComponent,
        TaskSelectionFiltersComponent,
        AutorFilterComponent,
        TaskTypeTreeViewComponent,
        TaskTrasferPopupComponent,
        TransferMedicoComponent,
        TransferAdministrativasComponent,
        TaskTrasferPopupComponent,
        TaskChangeDateComponent,
        ActuationSelectionFilterComponent,
        ActuationFilterComponent,
        ActuationListComponent,
        ActionTypeTreeViewComponent,
        TaskSelectionFiltersComponent,
        ComentariopopupComponent,
        AutorFilterComponent,
        OrdernFilterComponent,
        RecordingsPanelComponent,
        LeaveReportPopupComponent,
        TasksChangePopupComponent
    ],
    exports: [
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        AttributesFilterComponent,
        MainFiltersComponent,
        DatePeriodFilterComponent,
        LeaveTypeFilterComponent
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        RouterModule,
        AngularMaterialModule,
        SharedModule,
        NgSelectModule,
        FuseShortcutsModule,
        MatExpansionModule,
        MatTooltipModule,
        SelectionGenericRoutingModule
    ],
    providers: [
        SelectionGenericService,
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class SelectionGenericModule {

}
